import React from 'react';
import { motion } from 'framer-motion';
interface SectionProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
  delay?: number;
}
export function Section({
  children,
  className = '',
  id,
  delay = 0
}: SectionProps) {
  return <section id={id} className={`py-16 md:py-24 px-4 sm:px-6 lg:px-8 overflow-hidden relative ${className}`} data-id="element-400">
      <motion.div initial={{
      opacity: 0,
      y: 60,
      scale: 0.96,
      filter: 'blur(12px)'
    }} whileInView={{
      opacity: 1,
      y: 0,
      scale: 1,
      filter: 'blur(0px)'
    }} viewport={{
      once: true,
      margin: '-80px'
    }} transition={{
      duration: 1.2,
      delay,
      ease: [0.25, 0.46, 0.45, 0.94]
    }} className="max-w-4xl mx-auto" data-id="element-401">
        {children}
      </motion.div>
    </section>;
}